import axios from '../axios';

export const all = () => {
  return axios.get('/guarantee-details').then((res) => res.data);
};

export const update = (payload) => {
  return axios.put(`/guarantee-details/${payload.id}`, payload);
};
